import { AmbassadorUsersBanner } from 'app/components/ambassador-users';
import { InsuredUser } from 'app/components/insured-users';
import { Column, Row } from 'app/design/primitives/box';
import type { useDesktopLandingData } from '../use-desktop-landing-data';

export function LandingTrustBanners({
  canBecomeAmbassador,
  insuredUsers,
  user,
}: Pick<ReturnType<typeof useDesktopLandingData>, 'canBecomeAmbassador' | 'insuredUsers' | 'user'>) {
  if (!insuredUsers && !canBecomeAmbassador) return null;
  return (
    <Row alignItems="stretch" justifyContent="center" gap="spacing.general.x4">
      {canBecomeAmbassador ? (
        <Column flex={insuredUsers ? 1 : undefined} width={insuredUsers ? undefined : '100%'}>
          <AmbassadorUsersBanner />
        </Column>
      ) : null}
      {insuredUsers ? (
        <Column flex={canBecomeAmbassador ? 1 : undefined} width={canBecomeAmbassador ? undefined : '100%'}>
          <InsuredUser placement="landing-page" otherUser={user} />
        </Column>
      ) : null}
    </Row>
  );
}
